import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { FileText, Lock } from 'lucide-react';
import { TERMS_OF_USE, PRIVACY_POLICY, TERMS_LAST_UPDATE } from '../data/termsContent';

const Section = ({ title, body }) => (
  <div className="mb-4">
    <h4 className="text-sm font-semibold text-slate-800 mb-1">{title}</h4>
    <p className="text-sm text-slate-600 leading-relaxed">{body}</p>
  </div>
);

/**
 * Visualizador (somente leitura) dos Termos de Uso e Politica de Privacidade.
 * Recebe um `trigger` (elemento clicavel). Se nao informado, usa um link padrao.
 */
export const TermsViewerDialog = ({ trigger }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <button
            type="button"
            className="text-sm text-teal-700 hover:text-teal-800 hover:underline font-medium"
            data-testid="view-terms-link"
          >
            Ver Termos de Uso e Política de Privacidade
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-3xl max-h-[88vh] flex flex-col p-0 overflow-hidden">
        <DialogHeader className="px-6 py-4 border-b border-slate-100">
          <DialogTitle className="text-xl font-bold text-slate-900">
            Termos de Uso e Política de Privacidade
          </DialogTitle>
          <p className="text-sm text-slate-500">Atualizado em {TERMS_LAST_UPDATE}</p>
        </DialogHeader>
        <div className="px-6 py-4 overflow-y-auto" data-testid="terms-viewer-content">
          <div className="flex items-center gap-2 mb-3">
            <FileText className="h-4 w-4 text-teal-700" />
            <h3 className="text-base font-bold text-slate-900">Termos de Uso</h3>
          </div>
          {TERMS_OF_USE.map((s) => (
            <Section key={s.title} title={s.title} body={s.body} />
          ))}
          <div className="flex items-center gap-2 mt-6 mb-3">
            <Lock className="h-4 w-4 text-teal-700" />
            <h3 className="text-base font-bold text-slate-900">Política de Privacidade (LGPD)</h3>
          </div>
          {PRIVACY_POLICY.map((s) => (
            <Section key={s.title} title={s.title} body={s.body} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsViewerDialog;
